import { inProse, type TypeLabel } from './pluralise.js';

/**
 * The entity types, named once. This replaces the old registry-backed labels hook, which asked the server at
 * runtime for labels the client can perfectly well know.
 */
export type EntityType = 'studio' | 'game' | 'config';

export const LABELS: Record<EntityType, TypeLabel> = {
    studio: { singular: 'Studio', plural: 'Studios' },
    game: { singular: 'Game', plural: 'Games' },
    config: { singular: 'Config', plural: 'Configs' },
};

export const isEntityType = (type: string): type is EntityType => Object.hasOwn(LABELS, type);

export const labelOf = (type: string): TypeLabel =>
    isEntityType(type) ? LABELS[type] : { singular: type, plural: type };

export const countOf = (type: string, n: number): string => inProse(labelOf(type), n);
